export default __webpack_public_path__ + "static/media/zone-templates.cecbaa6c.svg";